import { render, staticRenderFns } from "./AdminConfiguration.vue?vue&type=template&id=fa049268&scoped=true"
import script from "./AdminConfiguration.vue?vue&type=script&lang=js"
export * from "./AdminConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AdminConfiguration.vue?vue&type=style&index=0&id=fa049268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa049268",
  null
  
)

export default component.exports